import { render, staticRenderFns } from "./ChildName.vue?vue&type=template&id=81b1821c&scoped=true&"
import script from "./ChildName.vue?vue&type=script&lang=js&"
export * from "./ChildName.vue?vue&type=script&lang=js&"
import style0 from "./ChildName.vue?vue&type=style&index=0&id=81b1821c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81b1821c",
  null
  
)

export default component.exports